// extracted by mini-css-extract-plugin
export default {"container":"PIHHlPxGqtw_nCdC7CWO"};